module.exports = "<lbpa-app-header logo=\"assets/images/white_label.png\" [showHeader]=\"checkDisplayHeaderFooter()\"></lbpa-app-header>\n\n<!-- Begin page content -->\n<pes-app-container></pes-app-container>\n\n<lbpa-footer [showFooter]=\"checkDisplayHeaderFooter()\"></lbpa-footer>\n\n<pes-notifications></pes-notifications>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 5xMp
// module chunks = 1